export interface QuestionState {
  id: string;
  attempts: QuestionAttempt[];
}

export function defaultQuestionState(id: string): QuestionState {
  return { id, attempts: [] };
}

//export type QuestionResult = 'passed' | 'failed' | 'neutral';

interface QuestionAttempt {
  timestamp: Date;
  response: string;
  score: number;
  durationSeconds: number;
}
